var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-industry-view"},[_c('StockIndustry')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }